"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowState = void 0;
var WindowState;
(function (WindowState) {
    WindowState["Hidden"] = "hidden";
    WindowState["Normal"] = "normal";
    WindowState["Minimized"] = "minimized";
    WindowState["Maximize"] = "maximize";
    WindowState["Closed"] = "closed";
})(WindowState = exports.WindowState || (exports.WindowState = {}));
//# sourceMappingURL=window_state.js.map